<template>
  <div class="allenamento-dettaglio">
    <div
    v-for="(dettaglio, index) in allenamento.dettagli"
class="fase"
    :key="index"
    >
        <h3>
            <span class="dettaglio-fase">
                {{dettaglio.des_attivita}}
            </span>
        </h3>
    <div class="pre" v-html="dettaglio.note_attivita"></div>
  </div>
  </div>
</template>

<script>
export default {
  props: ['allenamento']
}
</script>

<style lang="scss">
</style>
